import { useEffect, useRef, useState } from "react";
import { Document, Page } from "react-pdf";

export default function PdfPreviewLayout({ blob }: { blob: Blob }) {
  const wrapRef = useRef<HTMLDivElement>(null);
  const [pageWidth, setPageWidth] = useState<number | undefined>(undefined);
  const [pageHeight, setPageHeight] = useState<number | undefined>(undefined);

  // ResizeObserver: 컨테이너 크기 변할 때마다 폭 계산
  useEffect(() => {
    if (!wrapRef.current) return;
    const observer = new ResizeObserver(() => {
      const w = wrapRef.current!.offsetWidth;
      setPageWidth(w);
    });
    observer.observe(wrapRef.current);
    // 초기값 한 번 설정
    setPageWidth(wrapRef.current.offsetWidth);
    setPageHeight(wrapRef.current.offsetHeight);
    return () => observer.disconnect();
  }, []);

  return (
    <div ref={wrapRef} style={{ width: "100%", height: "100%" }}>
      <Document file={blob}>
        <Page
          pageNumber={1}
          width={pageWidth}              // ← 컨테이너 폭에 맞춤
          height={pageHeight}
          renderTextLayer={false}
          renderAnnotationLayer={false}
        />
      </Document>
    </div>
  );
}
